<script>
import Modal from '../../../components/Modal.vue'
import { debounce } from 'lodash'
import VueSelect from 'vue-select'

export default {
    components: {
        Modal,
        VueSelect,
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        from: {
            type: String,
            default: null
        },
        requisitionId: {
            type: String,
            default: null
        }
    },

    computed: {
        filteredRequisitionJobs() {
            return this.requisitionJobs.filter(job => job.id !== this.jobApplication.job_id)
        },
        reason() {
            return this.selectedOption.title;
        }
    },

    mounted() {
        this.fetchRequisitionJobs();
    },

    data() {
        return {
            requisitionJobs: [],
            recycleJob: null,
            selectedOption: '',
            reasons: [
                {'title': 'Language proficiency more suitable to the local market'},
                {'title': 'Candidate cannot work at night / do night shift'},
                {'title': 'Additionally recruited / Overflow candidate'},
                {'title': 'Candidate better suited to a customer service environment'},
                {'title': 'Candidate better suited to a sales environment'},
                {'title': 'Candidate better suited to a technical environment'},
            ],
        }
    },

    methods: {
        fetchRequisitionJobs(search = '', loading = null) {
            if (loading) loading(true);
            this.search(`/recruiter/active-requisitions/jobs.json?search=${search}&limit=1000`, loading, json => {
                this.requisitionJobs = json.jobs
            });
        },
        search: debounce((url, loading, mapResult) => {
            fetch(url).then(res => {
                res.json().then(mapResult);
                if (loading) loading(false);
            });
        }, 250),
        toggleModal() {
            this.$refs.modal.toggle()
        }
    }
}
</script>

<template>
    <modal ref="modal" heading="Recycle Applicant">
        <h1>Recycling {{ jobApplication.user.full_name }}</h1>

        <form method="POST"
            :action="`/recruiter/active-requisitions/recycle/${jobApplication.id}?from=${this.from}&requisition_id=${this.requisitionId}`">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />

            <div class="mb-4">
                <label>Pick Job</label>

                <input name="job_id" type="hidden" :value="recycleJob ? recycleJob.id : null" />
                <input name="reason" type="hidden" :value="reason ? reason : null" />

                <vue-select
                    label="title"
                    @search="fetchRequisitionJobs"
                    @open="fetchRequisitionJobs"
                    :options="requisitionJobs"
                    v-model="recycleJob"
                >
                    <template slot="option" slot-scope="option">
                        {{ option.title }} (#{{ option.requisition_id }}, {{ option.requisition.person_specification.business_line.company.title }})
                    </template>
                </vue-select>
                <label>Reason</label>
                <vue-select label="title" name="reason" id="reason" :options="reasons" v-model="selectedOption">
                    <template slot="option" slot-scope="option">
                        {{ option.title }}
                    </template>
                </vue-select>
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button primary" type="submit">Recycle</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
    </modal>
</template>

<style>
.select-box {
    height: 50px;
    border-radius: 2px;
}
</style>